import { CurrentUser } from "@/components/Page";
import {
  OrderCarouselQuery,
  RecipeQuery,
} from "@/queries/autogenerate/graphql";
import { isStudent } from "./util";

export const isRecipeLocked = (
  recipe: OrderCarouselQuery["recipes"][number],
  user: CurrentUser
) =>
  !!(
    (isStudent(user) && (!user.school?.permModifyRecipes || recipe.locked)) ||
    (recipe.locked && recipe.lockedBy)
  );
